import React from "react";
import "./index.css";
import { useAuth } from "./provider/auth";
import { ModalProvider } from "./provider/modal";
import { ConfigProvider } from "./provider/config";

import CustomRoutes from "./routes";

export function App() {
  const { auth, authActions } = useAuth();
  const params = new URLSearchParams(window.location.search);

  if (window.location.search) {
    if (params.get("config") === "watch") {
      // Guarda info de video en LocalStorage
      authActions.setCookie();
    } else if (params.get("v")) {
      // No hacer nada
    } else {
      localStorage.clear();
      authActions.setCookie();
    }
  }

  if (auth.cookies.brand) {
    authActions.setBranding(auth.cookies.brand);
  }

  return (
    <ModalProvider>
      <ConfigProvider>
        <CustomRoutes />
      </ConfigProvider>
    </ModalProvider>
  );
}
